import { PGCode } from "@/types";
import { IPaymentMethod } from "./paymentMethod.types";

export class PaymentMethod implements IPaymentMethod {
  readonly pgCode: PGCode;
  readonly name: string;
  readonly displayText: string;

  constructor(data: IPaymentMethod) {
    this.pgCode = data.pgCode;
    this.name = data.name;
    this.displayText = data.displayText;
  }
}
